import { useParams } from "react-router-dom";
import AgentShowRenderer from "~/components/agent/AgentShowRenderer";
import { CommandJob } from "~/components/build/Show/lib/types";
import { useReactRouterNavigateHandler } from "~/components/build/Show/lib/useReactRouterNavigateHandler";
import Spinner from "~/components/shared/Spinner";

export default function AgentTab({ job }: { job: CommandJob }) {
  const { org = "" } = useParams<{ org: string }>();
  const linkClickHandler = useReactRouterNavigateHandler();

  if (job.agentUuid) {
    return (
      <div className="py-2.5" onClick={linkClickHandler}>
        <AgentShowRenderer params={{ agent: job.agentUuid, organization: org }} />
      </div>
    );
  }

  if (job.agentsPath) {
    return (
      <div className="py-2.5">
        <span className="flex items-center gap-2">
          <Spinner color={false} />
          <a href={job.agentsPath} className="text-inherit hover:text-inherit">
            {job.clusterQueue?.key ? (
              <span className="inline-flex gap-1">
                Waiting for agent in queue:
                <span className="font-medium">{job.clusterQueue?.key}</span>
              </span>
            ) : (
              <span className="hover:underline">Waiting for agent</span>
            )}
          </a>
        </span>
      </div>
    );
  }

  return null;
}
